export default __webpack_public_path__ + "static/media/boy_girl_with_money.80d7dda2.png";